import { render, staticRenderFns } from "./No01.vue?vue&type=template&id=907a71c2&scoped=true"
import script from "./No01.vue?vue&type=script&lang=js"
export * from "./No01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907a71c2",
  null
  
)

export default component.exports